"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PREVIEWER_STATE_CONSTANTS;
(function (PREVIEWER_STATE_CONSTANTS) {
    PREVIEWER_STATE_CONSTANTS["UPDATE_ROUTE_STACK"] = "fYTGrSEhhzXreNvEJ62223";
    PREVIEWER_STATE_CONSTANTS["UPDATE_SIDE_MENU"] = "kldhaj2k2hzXresfs2ds21";
})(PREVIEWER_STATE_CONSTANTS || (PREVIEWER_STATE_CONSTANTS = {}));
exports.default = PREVIEWER_STATE_CONSTANTS;
